import React from "react";
import { CardHeader, CardTitle, Form, Row } from "reactstrap";
import useCurrentSaleStore from "stores/SaleStore";
import LabelAndInput from "./LabelAndInput";
import DMVFee from "./saleComponents/DMVFee";
import NetTrade from "./saleComponents/NetTrade";
import SellerFees from "./saleComponents/SellerFees";
import Taxes from "./saleComponents/Taxes";
import InsuranceAndGAP from "./saleComponents/InsuranceAndGAP";
import ServiceContract from "./saleComponents/ServiceContract";
import Aftermarket from "./saleComponents/Aftermarket";
import DownPayment from "./saleComponents/DownPayment";
import DeferredPickup from "./saleComponents/DeferredPickup";
import { DealStatus } from "constants/Constants";
import useCurrentDealStore from "stores/DealStore";
import TaxCountySelector from "../taxCountySelector/TaxCountySelector";
import formNavigationUtils from "utils/formNavigationUtils";
import shallow from "zustand/shallow";
import ContractInfo from "../dealDetails/ContractInfoDetail";
import useCurrentLeaseStore from "../../../../stores/LeaseStore";
import LeaseFees from "./saleComponents/LeaseFees";
import Mileage from "./saleComponents/Mileage";
import LsTaxes from "./saleComponents/LsTaxes";
import { calculateResidualValue } from "../../helperFunctions/LeaseFunctions";

/**
 * Sale component displays the sale details and inputs for a deal.
 *
 * @returns {JSX.Element} The rendered component
 */
const Lease_Sale = () => {
	const lease = useCurrentLeaseStore((state) => ({ ...state }), shallow);
	console.log(lease);

	const { type, taxRegion, totalCost } = useCurrentDealStore(
		(state) => ({
			type: state.deal.type,
			taxRegion: state?.deal?.dealSettings?.taxDefaults?.taxRegion,
			totalCost: state.vehicle?.totalCost || 0,
		}),
		shallow
	);

	const handleMsrp = () => {
		console.log("MSRP", lease?.price);
		// Only for Lease: sync MSRP from price if MSRP is 0
		if (lease.leaseType === 5) {
			(lease?.msrp ?? 0) === 0 && lease.editField("msrp", lease?.price ?? 0);
		}
	};

	const handlePrice = () => {
		console.log("PRICE handling", { price: lease?.price, leaseType: lease.leaseType });

		// For Lease (leaseType 5): sync price from MSRP if price is 0
		if (lease.leaseType === 5) {
			(lease?.price ?? 0) === 0 && lease.editField("price", lease?.msrp ?? 0);
		}

		// For RTO (leaseType 6): update markup and multiplier based on price
		if (lease.leaseType === 6 && totalCost > 0) {
			const newPrice = lease?.price ?? 0;
			const newMarkup = newPrice - totalCost;
			const newMultiplier = newPrice / totalCost;
			console.log("Updating RTO markup/multiplier", { newPrice, newMarkup, newMultiplier, totalCost });
			lease.editField("markup", newMarkup);
			// multiplier is derived, not stored, so we don't need to set it
		}

		// Update residual value for both Lease and RTO
		const baseValue = lease.leaseType === 6 ? lease.price : lease.msrp;
		const ressValue = calculateResidualValue(baseValue, lease.residualFactor);
		console.log(ressValue);
		lease.editField("residualValue", ressValue);
	};

	return (
		<div>
			<CardHeader>
				<CardTitle tag="h3">
					{type} {lease.leaseType === 5 ? "Lease" : "RTO"}{" "}
				</CardTitle>
			</CardHeader>
			<div className="card-body pb-3" onKeyDown={formNavigationUtils}>
				<Form className="deal-sale">
					<Row className="align-items-center sale-container">
						{lease.leaseType === 5 && (
							<div className="sale-item">
								<LabelAndInput
									name="MSRP"
									disabled={type !== DealStatus.PENDING}
									value={lease?.msrp ?? 0}
									label="M.S.R.P"
									onChange={(e) => lease.editField("msrp", e)}
									onBlur={handlePrice}
									btnClass="w-100 btn-md btn-primary btn"
									buttonLabel="true"
								/>
							</div>
						)}

						<div className="sale-item">
							<LabelAndInput
								name="dealPrice"
								disabled={type !== DealStatus.PENDING}
								value={lease?.price ?? 0}
								label="Price"
								onChange={(e) => lease.editField("price", e)}
								onBlur={handleMsrp}
								btnClass="w-100 btn-md btn-primary btn"
								buttonLabel="true"
							/>
						</div>
						<div className="sale-item">
							<DMVFee />
						</div>
						<div className="sale-item">
							<LeaseFees />
						</div>

						<hr className="mb-3 w-75 mx-auto noDesktop" />

						<div className="sale-item">
							<InsuranceAndGAP />
						</div>
						<div className="sale-item">
							<ServiceContract />
						</div>
						<div className="sale-item">
							<Aftermarket />
						</div>
						<div className="sale-item">
							<Mileage />
						</div>

						<hr className="mb-3 w-75 mx-auto noDesktop" />

						<div className="sale-item">
							<ContractInfo />
						</div>
						<div className="sale-item">
							<NetTrade />
						</div>
						<div className="sale-item">
							<DownPayment />
						</div>

						<hr className="mb-3 w-75 mx-auto noDesktop" />

						{lease.leaseType === 5 && (
							<div className="sale-item">
								<LabelAndInput
									name="dealMFR"
									className="text-danger bold"
									disabled={type !== DealStatus.PENDING}
									buttonLabel={true}
									value={lease?.lsRebate ?? 0}
									label="MFR Rebate"
									onChange={(e) => lease.editField("lsRebate", e)}
									sign="-"
									btnClass="w-100 btn-md btn-primary btn px-0"
								/>
							</div>
						)}
						<div className="sale-item">
							<DeferredPickup />
						</div>
						<div className="sale-item">
							<LsTaxes />
						</div>
						<div className="col-12 p-0">
							<hr className="my-2 w-75 mx-auto" />
							<TaxCountySelector localTaxRegion={taxRegion} />
						</div>
					</Row>
				</Form>
			</div>
		</div>
	);
};

export default Lease_Sale;
